import { useId, useState, type ReactNode } from "react";
import { CopyButton } from "./CopyButton";

/**
 * The collapsed home for raw JSON, stack traces and message bodies (spec §5.2).
 *
 * This is the boundary between the two audiences: a CS reader never scrolls
 * past a payload to find the next thing to do, and an engineer is one click
 * and one copy button away from the whole of it.
 */
export function TechnicalDetails({
  title = "Technical details",
  copyText,
  defaultOpen = false,
  children,
}: {
  title?: string;
  copyText?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();
  return (
    <section className="techdetails">
      <div className="techdetails__head">
        <button
          type="button"
          className="techdetails__toggle uppercase-label"
          aria-expanded={open}
          aria-controls={bodyId}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`techdetails__chevron${open ? " techdetails__chevron--open" : ""}`} aria-hidden="true">
            ▸
          </span>
          {title}
        </button>
        {copyText !== undefined ? <CopyButton value={copyText} /> : null}
      </div>
      {open ? (
        <div className="techdetails__body" id={bodyId}>
          {children}
        </div>
      ) : null}
    </section>
  );
}
